module.exports = __webpack_public_path__ + "static/media/special-offer_en.b5adaa4b.svg";